const r = {
  object: (t) => typeof t == "object" && t !== null && !Array.isArray(t),
  string: (t) => typeof t == "string",
  null: (t) => t === null
};
export {
  r as i
};
